import { Box, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export interface ListSelectionProps {
  moveEntireCrew: boolean;
  hasPendingCrewChangeRequest?: boolean;
}

export const ListSelectionStyled = styled(Box).attrs({
  py: { sm: '300' },
  px: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})<ListSelectionProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }

  ${({ hasPendingCrewChangeRequest, moveEntireCrew }) =>
    (hasPendingCrewChangeRequest || moveEntireCrew) &&
    css`
      cursor: auto;
      &:hover {
        background-color: ${({ theme }) => theme.colors.white};
      }
    `}
`;

export const CraftHeaderStyled = styled(Text).attrs({
  size: '400',
  color: 'grey.1000',
  weight: '600',
})`
  padding-top: ${({ theme }) => theme.spacings[200]};
  padding-bottom: ${({ theme }) => theme.spacings[200]};
  white-space: nowrap;
`;
